(function(){
  const wrapper = document.getElementById('live-search-wrapper');
  const input = document.getElementById('live-search-input');
  const resultsBox = document.getElementById('live-search-results');
  if (!wrapper || !input || !resultsBox) return;

  let debounceTimer;
  let currentController;

  function escapeHtml(str){
    return (str || '').replace(/[&<>"']/g, m => ({
      '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
    }[m]));
  }

  function formatMoney(value){
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney && typeof window.moneyFormat !== 'undefined') {
    return Shopify.formatMoney(value * 100, window.moneyFormat);
  }
  return 'Rs. ' + Number(value).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

  function renderResults(data, query){
    const products = data.resources.results.products || [];
    const collections = data.resources.results.collections || [];

    if (!products.length && !collections.length) {
      resultsBox.innerHTML = '<div class="live-search-empty">No results for "' + escapeHtml(query) + '"</div>';
      resultsBox.classList.add('active');
      return;
    }

    let html = '<div class="live-search-inner">';

    if (collections.length) {
      html += '<div class="live-search-section-title">Collections</div>';
      collections.forEach(c => {
        html += `
          <a href="${c.url}" class="live-search-item live-search-item--collection">
            <span class="live-search-thumb live-search-thumb--icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 7H20M4 12H20M4 17H14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            </span>
            <div class="live-search-item-info">
              <span class="live-search-item-title">${escapeHtml(c.title)}</span>
            </div>
            <svg class="live-search-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </a>`;
      });
    }

    if (products.length) {
  html += '<div class="live-search-section-title">Products</div>';
  products.forEach(p => {

    const priceNum = parseFloat(p.price_min);
    const compareNum = parseFloat(p.compare_at_price_min);

    const hasCompare = !isNaN(compareNum) && compareNum > priceNum;

    let discountPercentage = 0;
    if (hasCompare) {
      discountPercentage = Math.round(((compareNum - priceNum) * 100) / compareNum);
    }

    html += `
      <a href="${p.url}" class="live-search-item">
        <span class="live-search-thumb">
          ${p.image ? `<img src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}
        </span>
        <div class="live-search-item-info">
          <span class="live-search-item-title">${escapeHtml(p.title)}</span>
          <span class="live-search-item-price">
            <span class="live-search-price-current">${p.price}</span>
            ${hasCompare ? `<s class="live-search-price-compare">${formatMoney(compareNum)}</s>` : ''}
            ${hasCompare ? `<span class="live-search-discount-badge">${discountPercentage}% OFF</span>` : ''}
          </span>
        </div>
        <svg class="live-search-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </a>`;
  });
}

    html += `</div><a href="/search?q=${encodeURIComponent(query)}" class="live-search-view-all">
      View all results for "${escapeHtml(query)}"
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </a>`;

    resultsBox.innerHTML = html;
    resultsBox.classList.add('active');
  }

  function fetchResults(query){
    if (currentController) currentController.abort();
    currentController = new AbortController();

    resultsBox.innerHTML = '<div class="live-search-loading">Searching...</div>';
    resultsBox.classList.add('active');

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last`, {
      signal: currentController.signal
    })
      .then(res => res.json())
      .then(data => renderResults(data, query))
      .catch(err => {
        if (err.name !== 'AbortError') {
          resultsBox.innerHTML = '<div class="live-search-empty">Something went wrong. Try again.</div>';
        }
      });
  }

  input.addEventListener('input', function(){
    const query = this.value.trim();

    clearTimeout(debounceTimer);

    if (query.length < 2) {
      resultsBox.classList.remove('active');
      resultsBox.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(() => fetchResults(query), 300);
  });

  input.addEventListener('focus', function(){
    if (this.value.trim().length >= 2 && resultsBox.innerHTML) {
      resultsBox.classList.add('active');
    }
  });

  document.addEventListener('click', function(e){
    if (!wrapper.contains(e.target)) {
      resultsBox.classList.remove('active');
    }
  });

  input.addEventListener('keydown', function(e){
    if (e.key === 'Escape') {
      resultsBox.classList.remove('active');
      this.blur();
    }
  });
})();

/* ===============================
   MOBILE MEGA MENU DRAWER
================================ */

// (function(){

//   document.addEventListener("DOMContentLoaded", function(){

//     const categoryBtn = document.querySelector(".category-btn");

//     if(!categoryBtn) return;


//     const megaParents = document.querySelectorAll(".mega-parent");

//     if(!megaParents.length) return;


//     const overlay = document.createElement("div");
//     overlay.className = "mobile-mega-overlay";


//     const drawer = document.createElement("div");
//     drawer.className = "mobile-mega-drawer";


//     let sidebarHTML = "";
//     let contentHTML = "";


//     megaParents.forEach((parent,index)=>{


//       const parentLink = parent.querySelector(":scope > a");

//       if(!parentLink) return;


//       const title = parentLink.textContent.trim();

//       const panelID = "mobile-mega-panel-"+index;


//       sidebarHTML += `

//         <button 
//           class="mobile-mega-tab ${index===0?'active':''}"
//           data-panel="${panelID}">
//             ${title}
//         </button>

//       `;



//       const children = parent.querySelectorAll(
//         ".mega-item:not(.mega-item-view-all)"
//       );


//       contentHTML += `

//         <div 
//           class="mobile-mega-panel ${index===0?'active':''}"
//           id="${panelID}">


//           <div class="mobile-mega-title">
//              ${title}
//           </div>


//           <div class="mobile-mega-grid">


//             <a href="${parentLink.href}" 
//                class="mobile-mega-card">


//              <div class="mobile-mega-image view-all">

//               <div class="view-all-circle-icon">

//                       <svg viewBox="0 0 24 24">
//                           <path d="M12 5V19"/>
//                           <path d="M5 12H19"/>
//                       </svg>

//                   </div>

//               </div>

//               <span>
//                 View All
//               </span>

//             </a>


//       `;



//       children.forEach(child=>{


//         const img = child.querySelector("img");

//         const image = img ? img.src : "";

//         const text = child.textContent.trim();



//         contentHTML += `


//           <a href="${child.href}" 
//              class="mobile-mega-card">


//              <div class="mobile-mega-image">


//                 ${
//                   image
//                   ?
//                   `<img src="${image}" loading="lazy">`
//                   :
//                   ""
//                 }


//              </div>


//              <span>
//                 ${text}
//              </span>


//           </a>


//         `;


//       });



//       contentHTML += `

//           </div>

//         </div>


//       `;


//     });



//     drawer.innerHTML = `


//       <div class="mobile-mega-header">

//           <span>
//              Categories
//           </span>


//           <button class="mobile-mega-close">
//              ×
//           </button>


//       </div>



//       <div class="mobile-mega-layout">


//           <div class="mobile-mega-sidebar">


//               ${sidebarHTML}


//           </div>



//           <div class="mobile-mega-content">


//               ${contentHTML}


//           </div>


//       </div>


//     `;



//     document.body.appendChild(overlay);

//     document.body.appendChild(drawer);



//     const tabs = drawer.querySelectorAll(".mobile-mega-tab");

//     const panels = drawer.querySelectorAll(".mobile-mega-panel");



//     tabs.forEach(tab=>{


//       tab.addEventListener("click",()=>{


//         const id = tab.dataset.panel;



//         tabs.forEach(t=>{
//           t.classList.remove("active");
//         });


//         panels.forEach(p=>{
//           p.classList.remove("active");
//         });



//         tab.classList.add("active");


//         const panel = drawer.querySelector("#"+id);


//         if(panel){
//           panel.classList.add("active");
//         }


//       });


//     });





//     function openMenu(){


//       overlay.classList.add("active");

//       drawer.classList.add("active");

//       document.body.style.overflow="hidden";


//     }



//     function closeMenu(){


//       overlay.classList.remove("active");

//       drawer.classList.remove("active");

//       document.body.style.overflow="";


//     }



//     categoryBtn.addEventListener("click",function(e){


//       if(window.innerWidth <= 768){

//         e.preventDefault();

//         openMenu();

//       }


//     });



//     overlay.addEventListener("click",closeMenu);



//     drawer.querySelector(".mobile-mega-close")
//     .addEventListener("click",closeMenu);



//   });


// })();

/* ===============================
   MOBILE MEGA MENU DRAWER (SCROLL & HIGHLIGHT)
================================ */

(function(){

  document.addEventListener("DOMContentLoaded", function(){

    const categoryBtn = document.querySelector(".category-btn");
    if(!categoryBtn) return;

    const megaSections = document.querySelectorAll(".mega-content-scrollable .mega-section");
    if(!megaSections.length) return;

    const overlay = document.createElement("div");
    overlay.className = "mobile-mega-overlay";

    const drawer = document.createElement("div");
    drawer.className = "mobile-mega-drawer";

    let sidebarHTML = "";
    let sectionsHTML = "";

    megaSections.forEach((section, index) => {

      const headTitle = section.querySelector(".mega-section-head h4");
      const title = headTitle ? headTitle.textContent.trim() : `Category ${index + 1}`;
      const viewAllLink = section.querySelector(".mega-section-head .view-all")?.getAttribute("href") || "#";
      const targetID = "mobile-mega-section-" + index;

      sidebarHTML += `
        <button 
          class="mobile-mega-tab ${index === 0 ? 'active' : ''}"
          data-target="${targetID}">
            ${title}
        </button>
      `;

      const children = section.querySelectorAll(".mega-item:not(.mega-item-view-all)");

      // sectionsHTML += `
      //   <div class="mobile-mega-section" id="${targetID}">

      //     <div class="mobile-mega-title">
      //        ${title}
      //        <a href="${viewAllLink}" class="mobile-view-all-link">View All →</a>
      //     </div>

      //     <div class="mobile-mega-grid">

      //       <a href="${viewAllLink}" class="mobile-mega-card">
      //         <div class="mobile-mega-image view-all">
      //           <div class="view-all-circle-icon">
      //             <svg viewBox="0 0 24 24">
      //               <path d="M12 5V19"/>
      //               <path d="M5 12H19"/>
      //             </svg>
      //           </div>
      //         </div>
      //         <span>View All</span>
      //       </a>
      // `;
sectionsHTML += `
  <div class="mobile-mega-section" id="${targetID}">

    <div class="mobile-mega-title">
       ${title}
       <a href="${viewAllLink}" class="mobile-view-all-link">View All →</a>
    </div>

    <div class="mobile-mega-grid">
`;
      children.forEach(child => {
        const img = child.querySelector("img");
        const image = img ? img.src : "";
        const text = child.querySelector("span") ? child.querySelector("span").textContent.trim() : child.textContent.trim();
        const href = child.getAttribute("href") || "#";

        sectionsHTML += `
          <a href="${href}" class="mobile-mega-card">
             <div class="mobile-mega-image">
                ${image ? `<img src="${image}" loading="lazy">` : ""}
             </div>
             <span>${text}</span>
          </a>
        `;
      });

      sectionsHTML += `
          </div>
        </div>
      `;
    });

    drawer.innerHTML = `
      <div class="mobile-mega-header">
          <span>Categories</span>
          <button class="mobile-mega-close">×</button>
      </div>

      <div class="mobile-mega-layout">
          <div class="mobile-mega-sidebar">
              ${sidebarHTML}
          </div>
          <div class="mobile-mega-content-scrollable" id="mobile-mega-scroll-container">
              ${sectionsHTML}
          </div>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    const tabs = drawer.querySelectorAll(".mobile-mega-tab");
    const scrollContainer = drawer.querySelector("#mobile-mega-scroll-container");
    const mobileSections = drawer.querySelectorAll(".mobile-mega-section");

    // 1. Mobile Click-to-Scroll Functionality
    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        const targetId = tab.dataset.target;
        const targetSection = drawer.querySelector("#" + targetId);

        if (targetSection && scrollContainer) {
          scrollContainer.scrollTo({
            top: targetSection.offsetTop - scrollContainer.offsetTop,
            behavior: "smooth"
          });
        }
      });
    });

    // 2. Mobile Intersection Observer for Scroll-Based Highlighting
    // if (scrollContainer && mobileSections.length) {
    //   // const mobileObserverOptions = {
    //   //   root: scrollContainer,
    //   //   rootMargin: "0px",
    //   //   threshold: 0.25
    //   // };

    //   const mobileObserverOptions = {
    //     root: scrollContainer,
    //     rootMargin: "-10% 0px -70% 0px", // Top area detection logic
    //     threshold: 0
    //   };

    //   const mobileObserver = new IntersectionObserver((entries) => {
    //     entries.forEach((entry) => {
    //       if (entry.isIntersecting) {
    //         const id = entry.target.getAttribute("id");

    //         tabs.forEach((tab) => {
    //           if (tab.getAttribute("data-target") === id) {
    //             tab.classList.add("active");
    //           } else {
    //             tab.classList.remove("active");
    //           }
    //         });
    //       }
    //     });
    //   }, mobileObserverOptions);

    //   mobileSections.forEach((sec) => mobileObserver.observe(sec));
    // }

    // 2. Mobile Intersection Observer + Scroll Bottom Check
    if (scrollContainer && mobileSections.length) {
      const mobileObserverOptions = {
        root: scrollContainer,
        rootMargin: "-10% 0px -50% 0px",
        threshold: 0
      };

      const mobileObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute("id");
            tabs.forEach((tab) => {
              tab.classList.toggle("active", tab.getAttribute("data-target") === id);
            });
          }
        });
      }, mobileObserverOptions);

      mobileSections.forEach((sec) => mobileObserver.observe(sec));

      // Bottom scroll listener for Mobile
      scrollContainer.addEventListener("scroll", function () {
        const isAtBottom = Math.abs(
          scrollContainer.scrollHeight - scrollContainer.clientHeight - scrollContainer.scrollTop
        ) <= 5;

        if (isAtBottom) {
          const lastId = mobileSections[mobileSections.length - 1].getAttribute("id");
          tabs.forEach((tab) => {
            tab.classList.toggle("active", tab.getAttribute("data-target") === lastId);
          });
        }
      });
    }

    // function openMenu() {
    //   overlay.classList.add("active");
    //   drawer.classList.add("active");
    //   document.body.style.overflow = "hidden";
    // }

    function openMenu() {
      overlay.classList.add("active");
      drawer.classList.add("active");
      document.body.style.overflow = "hidden";

      // Fix: Default scroll reset & first tab activate on open
      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
      }
      tabs.forEach((tab, index) => {
        if (index === 0) {
          tab.classList.add("active");
        } else {
          tab.classList.remove("active");
        }
      });
    }

    function closeMenu() {
      overlay.classList.remove("active");
      drawer.classList.remove("active");
      document.body.style.overflow = "";
    }

    categoryBtn.addEventListener("click", function(e){
      if(window.innerWidth <= 900){
        e.preventDefault();
        openMenu();
      }
    });

    overlay.addEventListener("click", closeMenu);
    drawer.querySelector(".mobile-mega-close").addEventListener("click", closeMenu);

  });

})();

// document.addEventListener("DOMContentLoaded", function () {
//   const scrollContainer = document.getElementById("mega-content-scrollable");
//   const sidebarLinks = document.querySelectorAll(".mega-parent-link");
//   const sections = document.querySelectorAll(".mega-section");

//   if (!scrollContainer || !sidebarLinks.length || !sections.length) return;

//   // 1. Scroll-Based Auto Highlight (Intersection Observer)
//   const observerOptions = {
//     root: scrollContainer,
//     rootMargin: "0px",
//     threshold: 0.3 // Highlight when 30% section is visible
//   };

//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach((entry) => {
//       if (entry.isIntersecting) {
//         const id = entry.target.getAttribute("id");

//         sidebarLinks.forEach((link) => {
//           if (link.getAttribute("data-target") === id) {
//             link.classList.add("active");
//           } else {
//             link.classList.remove("active");
//           }
//         });
//       }
//     });
//   }, observerOptions);

//   sections.forEach((section) => observer.observe(section));

//   // 2. Click-to-Scroll Functionality
//   sidebarLinks.forEach((link) => {
//     link.addEventListener("click", function (e) {
//       e.preventDefault();
//       const targetId = this.getAttribute("data-target");
//       const targetSection = document.getElementById(targetId);

//       if (targetSection) {
//         scrollContainer.scrollTo({
//           top: targetSection.offsetTop - scrollContainer.offsetTop,
//           behavior: "smooth"
//         });
//       }
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const scrollContainer = document.getElementById("mega-content-scrollable");
  const sidebarLinks = document.querySelectorAll(".mega-parent-link");
  const sections = document.querySelectorAll(".mega-section");

  if (!scrollContainer || !sidebarLinks.length || !sections.length) return;

  function setActiveLink(targetId) {
    sidebarLinks.forEach((link) => {
      link.classList.toggle(
        "active",
        link.getAttribute("data-target") === targetId
      );
    });
  }

  function updateActiveSection() {
    const scrollTop = scrollContainer.scrollTop;
    const maxScrollTop =
      scrollContainer.scrollHeight - scrollContainer.clientHeight;

    // TOP
    if (scrollTop <= 5) {
      setActiveLink(sections[0].getAttribute("id"));
      return;
    }

    // BOTTOM
    if (scrollTop >= maxScrollTop - 5) {
      setActiveLink(sections[sections.length - 1].getAttribute("id"));
      return;
    }

    const containerRect = scrollContainer.getBoundingClientRect();

    // Use the vertical CENTER of the visible popup
    const containerCenter =
      containerRect.top + containerRect.height / 2;

    let activeSection = sections[0];
    let closestDistance = Infinity;

    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();

      const sectionCenter = rect.top + rect.height / 2;

      const distance = Math.abs(sectionCenter - containerCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        activeSection = section;
      }
    });

    setActiveLink(activeSection.getAttribute("id"));
  }

  scrollContainer.addEventListener("scroll", updateActiveSection, {
    passive: true
  });

  updateActiveSection();

  // Click-to-scroll
  sidebarLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const targetId = this.getAttribute("data-target");
      const targetSection = document.getElementById(targetId);

      if (!targetSection) return;

      const containerTop =
        scrollContainer.getBoundingClientRect().top;

      const sectionTop =
        targetSection.getBoundingClientRect().top;

      const scrollPosition =
        scrollContainer.scrollTop +
        (sectionTop - containerTop);

      scrollContainer.scrollTo({
        top: scrollPosition,
        behavior: "smooth"
      });
    });
  });
});